import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { toast } from "sonner";
import { AppShell } from "@/components/AppShell";
import { GridCard } from "@/components/cards";
import { useI18n } from "@/i18n/I18nContext";
import { api } from "@/lib/api";

export default function Recommendations() {
  const { t } = useI18n();
  const [pairs, setPairs] = useState([]);
  const [demo, setDemo] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/recommendations")
      .then((r) => { setPairs(r.data.pairs); setDemo(r.data.demo); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AppShell>
      <div className="flex items-center justify-between mb-1">
        <span />
        <button onClick={() => toast.info(t("recs.infoTip"))} className="text-emerald-600"><Info className="w-5 h-5" /></button>
      </div>
      <h1 className="font-heading text-4xl font-extrabold text-slate-900 mb-1">{t("recs.title")}</h1>
      <p className="text-slate-400 text-sm mb-5">{t("recs.subtitle")}</p>

      {demo && !loading && (
        <div className="bg-emerald-50 text-emerald-700 text-sm rounded-xl px-4 py-3 mb-4">
          {t("recs.demoNote")}
        </div>
      )}

      {loading ? (
        <p className="text-slate-400 text-center py-10">{t("common.loading")}</p>
      ) : pairs.length === 0 ? (
        <p className="text-slate-400 text-center py-10" data-testid="recs-empty">{t("recs.empty")}</p>
      ) : (
        <div className="space-y-4">
          {pairs.map((p, i) => (
            <div key={i} className="grid grid-cols-2 gap-3" data-testid={`recs-pair-${i}`}>
              <GridCard item={p.bad} badge="bad" />
              <GridCard item={p.good} badge="good" />
            </div>
          ))}
        </div>
      )}
    </AppShell>
  );
}
